import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";
import Countries from "./_components/countries";
import Hero from "./_components/hero";
import HowToUse from "./_components/how-to-use";
// import Jobs from "./_components/jobs";
import PopularCourse from "./_components/popular-course";
import SuccessStory from "./_components/successStory";

import WhyUseUs from "./_components/why-use-us";

export default function Home() {
  return (
    <WebLayout>
      <Hero />
      <Countries />
      <WhyUseUs />
      <HowToUse />
      {/* <Jobs /> */}
      <PopularCourse />
      <SuccessStory />
      <Platform />
      <Footer isPlatform={true} />
    </WebLayout>
  );
}
